import { useEffect } from "react";
import { useLatestCallback } from "./useLatestCallback";

export const useWindowKeydown = (callback) => {
  const onKey = useLatestCallback(callback);
  useEffect(() => {
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onKey]);
};